<mat-form-field [appearance]="appearance()" class="w-full">
  <mat-label>{{label()}}</mat-label>
  <mat-chip-grid #chipGrid aria-label="Liste d'utilisateurs sélectionnés"> @for(selectedItem of selectedItems; track selectedItem) { <mat-chip-row [removable]="true" (removed)="removeOption(selectedItem)">
    @if (selectedItem) {
      {{ getLabel(selectedItem) }}
    }
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row> }
</mat-chip-grid>
<input #autoCompleteChipInput [placeholder]="placeholder()" [matChipInputFor]="chipGrid" [formControl]="searchControl" [matAutocomplete]="auto" (focus)="focusInput()" />
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
  @for (item of filteredItems$ | async; track item) {
    <mat-option [value]="getValue(item)"> {{ getObjectLabel(item) }} </mat-option>
  }
</mat-autocomplete>
</mat-form-field>